// If using a module system (e.g. via vue-cli), import Vue and VueI18n and then call Vue.use(VueI18n).
import Vue from "vue";
import VueI18n from "vue-i18n";
import br from "./locations/br.js";
import es from "./locations/es.js";
import en from "./locations/en.js";
//
Vue.use(VueI18n);

const localeDefault = process.env.VUE_APP_LOCALE_DEFAULT;

// Ready translated locale messages
const messages = {
  es,
  br,
  en,
};

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: localeDefault ? localeDefault.toLowerCase() : "en", // set locale
  messages, // set locale messages
});

// Now the app has started!
export default i18n;
